import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Serverurl from "./Apiurl";
import SubmitIcon from "./images/SUBMIT-ICON.jpg";  
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
export default class TransactionsInsertForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectarrauto: [],
      vendorarrauto: [],
      insertVendorType: "1", agreed_cost: 0,
      selectedProjectInsert: null,previocn:"",paybill:"",
      selectedProjectInsert: null,
      selectedVendorInsert: null,errormessage:'',erropen:false,isDisabled:false,errorty:"error",submitbtn:"Submit",
      ts_pj_id: "",
      ts_vm_id: "",  ts_id: "",ts_status: "",
      ts_date: dayjs(),successMsg: "",
total_paid: 0,
outstanding_amount: 0,
      ts_amount: "",
      ts_mode: "",
      ts_remarks: "",
	  total_paid: 0,
outstanding_amount: 0,
      userid: sessionStorage.getItem("userid") || 1
    };
  }

loadTransactionOutstanding = (pj_id, vm_id) => {
	
axios.get(Serverurl +"ajaxtransactions.php" +"?action=getprojecttransactionoutstanding" +"&ts_pj_id=" +pj_id +"&ts_vm_id=" +vm_id+"&vm_type=" +this.state.insertVendorType)
    .then((res) => {
      const data = res.data?.[0] || {};

      this.setState({
        agreed_cost: data.ccm_agreedcost || 0,
        total_paid: data.total_paid || 0,
        outstanding_amount: data.outstanding_amount || 0
      });
    });
};
onProjectChange = (event, value) => {
  this.setState(
    {
      selectedProjectInsert: value,
      ts_pj_id: value ? value.pj_id : "",

       selectedVendorInsert: null,
      ts_vm_id: "",
      vendorarrauto: [],

      agreed_cost: 0,
      total_paid: 0,
      outstanding_amount: 0
    },
    () => {
      if (value?.pj_id) {
        // 
      }
    }
  );
};
componentDidMount() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("ts_id");

  if (id) {
    this.loadTransaction(id);
  }
}
loadTransaction = (id) => {
  axios
    .get(
      Serverurl +
      "ajaxtransactions.php?action=getall&ts_id=" +
      id
    )
    .then((res) => {
      if (res.data.length > 0) {
        const r = res.data[0];

        this.setState({
          ts_id: r.ts_id,

          selectedProjectInsert: {
            title: r.pj_projectname,
            pj_id: r.ts_pj_id
          },

          selectedVendorInsert: {
            title: r.vm_vendorname,
            vm_id: r.ts_vm_id
          },
insertVendorType:r.vm_type,
          ts_pj_id: r.ts_pj_id,
          ts_vm_id: r.ts_vm_id,

          ts_date: dayjs(r.ts_date),
          ts_amount: r.ts_amount,
          ts_mode: String(r.ts_mode),
		  ts_status: String(r.ts_status),
          ts_remarks: r.ts_remarks
        },()=>{ this.loadTransactionOutstanding(
          r.ts_pj_id,
          r.ts_vm_id
        );});

       
      }
    });
};
updateTransaction = () => {
  let formData = new FormData();

  formData.append("action", "update");
  formData.append("ts_id", this.state.ts_id);
  formData.append("ts_pj_id", this.state.ts_pj_id);
  formData.append("ts_vm_id", this.state.ts_vm_id);
  formData.append(
    "ts_date",
    this.state.ts_date.format("YYYY-MM-DD")
  );
  formData.append("ts_amount", this.state.ts_amount);
  formData.append("ts_mode", this.state.ts_mode);
  formData.append("ts_remarks", this.state.ts_remarks);
  formData.append("ts_status", this.state.ts_status);
  formData.append("userid", this.state.userid);
  

  axios
    .post(Serverurl + "ajaxtransactions.php", formData)
    .then(() => {
      this.setState({
        successMsg: "Record updated successfully!"
      });
    });
};
  /* PROJECT */
  onloadProjectBind = (event) => {
axios.get(Serverurl +"ajaxprojects.php" +"?action=getallprojectautoextender" +"&pj_isactive=0&projectname=" +encodeURIComponent(event.target.value))
      .then((res) => {
        this.setState({
          projectarrauto: (res.data || []).map((r) => ({
            title: r.pj_projectname,
            pj_id: r.pj_id
          }))
        });
      });
  };
onInsertVendorTypeChange = (e) => {
  this.setState({
    insertVendorType: e.target.value,
    ts_vm_id: "",
    selectedVendorInsert: null,
    vendorarrauto: [],
agreed_cost: 0,
    total_paid: 0,
    outstanding_amount: 0
  });
};
  /* VENDOR  */
  onloadVendorBind = (event) => {
axios.get(Serverurl +"ajaxtransactions.php" +"?action=vendortypeautoextender" +"&vm_vendorname=" +encodeURIComponent(event.target.value) +"&ts_pj_id="+this.state.ts_pj_id+"&vm_type=" +this.state.insertVendorType)
      .then((res) => {
        this.setState({
          vendorarrauto: (res.data || []).map((r) => ({
            title: r.vm_vendorname,
            vm_id: r.vm_id
          }))
        });
      });
  };
  /* INSERT  */
  insertVendor  = () => {
	  


if(this.state.ts_pj_id==="")
{
	
	this.setState({errormessage:"Please Select Project ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
}

if (this.state.ts_vm_id==="") {
	this.setState({errormessage:"Please Select Vendor ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}

if (this.state.insertVendorType!=="1") {

	if (this.state.ts_status==="" || this.state.ts_status==="0") {
		
		this.setState({errormessage:"Please Select Status ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
		 
	}
}
if (!this.state.ts_amount || Number(this.state.ts_amount) <= 0) {
this.setState({errormessage:"Please Enter Valid Amount ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
  
    if (this.state.ts_mode==="") {
this.setState({errormessage:"Please Select Mode of Payment",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
this.setState({isDisabled:true,errormessage:"",erropen:false,submitbtn:"Processing..."});


    let formData = new FormData();
	if(this.state.ts_id==="")
	{
	formData.append("action", "insert");
	  formData.append("ts_id", 0);
	  }
	else{
	  formData.append("action", "update");
  formData.append("ts_id", this.state.ts_id);
	}
 
    formData.append("ts_pj_id", this.state.ts_pj_id);
    formData.append("ts_vm_id", this.state.ts_vm_id);
    formData.append("ts_date", this.state.ts_date.format("YYYY-MM-DD"));
    formData.append("ts_amount", this.state.ts_amount);
    formData.append("ts_mode", this.state.ts_mode);
    formData.append("ts_remarks", this.state.ts_remarks);
	
    formData.append("userid", this.state.userid );
	
	if(this.state.insertVendorType==="1")
	{
		formData.append("ts_status", "0");
	}else{
	formData.append("ts_status", this.state.ts_status);
	}
  
	
	  if(this.state.paybill!='')
	  {
		  
		for (const key of Object.keys(this.state.paybill)) {
            formData.append('Filedata', this.state.paybill[key])
        } 
 formData.append('ts_bill','1')		
	  }else
	  {
		 formData.append('ts_bill',this.state.previocn)	  
	  
	  }
    axios.post(Serverurl + "ajaxtransactions.php", formData).then(() => {
      //alert("Inserted Successfully!");
this.setState({
isDisabled:false,errormessage:"Payment completed successfully!",erropen:true,
submitbtn:"Submit",errorty:"success",

  ts_pj_id: "",
  ts_vm_id: "",
  ts_date: dayjs(),
  ts_amount: "",
  ts_mode: "1",
  ts_remarks: "",

  selectedProjectInsert: null,
  selectedVendorInsert: null,

  insertVendorType: "1",

  total_paid: 0,
  outstanding_amount: 0
});
    });
  };
  
  onFileChange = (e) => {
  let imageFile = e.target.files[0];

  if (!imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
    this.setState({
      errormessage: "Please select a valid file (jpg, jpeg, png).",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

  if (imageFile.size > 916800) {
    this.setState({
      errormessage: "File size should be less than or equal to 900KB.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

  this.setState({ paybill: e.target.files, errormessage: "", open: false });
}
 render() {
  return (
  
      <div>
      
 <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
  } severity={this.state.errorty}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse>
	  
	    <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* PROJECT */}
        <div className="paytxtbox">
          <p><span className="validation">*</span>Project</p>

          <Autocomplete
            options={this.state.projectarrauto}
            value={this.state.selectedProjectInsert}
            onChange={this.onProjectChange}
            getOptionLabel={(o) => o.title || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                onChange={this.onloadProjectBind}
              />
            )}
          />
        </div>

        {/* VENDOR TYPE */}
        <div className="paytxtbox">
          <p><span className="validation">*</span>Vendor Type</p>

          <ul className="vendortypelist">
            <li>
              <label>
                <Radio
                  checked={
                    this.state.insertVendorType === "1"
                  }
                  value="1"
                  onChange={
                    this.onInsertVendorTypeChange
                  }
                />
                Mastri
              </label>
            </li>

            <li>
              <label>
                <Radio
                  checked={
                    this.state.insertVendorType === "2"
                  }
                  value="2"
                  onChange={
                    this.onInsertVendorTypeChange
                  }
                />
                Vendor
              </label>
            </li>

            <li>
              <label>
                <Radio
                  checked={
                    this.state.insertVendorType === "3"
                  }
                  value="3"
                  onChange={
                    this.onInsertVendorTypeChange
                  }
                />
                Service
              </label>
            </li>
          </ul>
        </div>

        {/* VENDOR */}
        <div className="paytxtbox">
          <p>Vendor</p>

          <Autocomplete
            options={this.state.vendorarrauto}
            value={this.state.selectedVendorInsert}
          onChange={(e, v) =>
  this.setState(
    {
      selectedVendorInsert: v,
      ts_vm_id: v ? v.vm_id : ""
    },
    () => {
      if (this.state.ts_pj_id && v?.vm_id) {
        this.loadTransactionOutstanding(
          this.state.ts_pj_id,
          v.vm_id
        );
      }
    }
  )
}
  getOptionLabel={(o) => o.title || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                onChange={this.onloadVendorBind}
              />
            )}
          />
        </div>
{this.state.selectedVendorInsert && (
  <div className="paytxtbox">
    <p
      style={{
        color: "green",
       
      }}
    >{
  this.state.insertVendorType === "1" 
    ? "Labour Cost" 
    : this.state.insertVendorType === "2" 
      ? "Cost" 
      : this.state.insertVendorType === "3" 
        ? "Agreed Cost" 
        : ""
}
	  
	  : ₹ {this.state.agreed_cost}
    </p>
  </div>
)}
        {/* DATE */}
        <div className="txtprojfrm">
          <p> <span className="validation">*</span>Date</p>

          <DatePicker
            value={this.state.ts_date}
            onChange={(v) =>
              this.setState({ ts_date: v })
            }
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true
              }
            }}
            format="DD/MM/YYYY"
          />
        </div>
		
		
		{/* STATUS TYPE */}
	{(this.state.insertVendorType === "2" || this.state.insertVendorType === "3") && (
<div className="txtprojfrmryt">
  <p > <span className="validation">*</span>Status</p>

  <ul className="vendorlist">
    <li>
      <label>
        <Radio
          checked={this.state.ts_status === "1"}
          value="1"
          onChange={(e) =>
            this.setState({
              ts_status: e.target.value
            })
          }
        />
        Yet to be Claimed
      </label>
    </li>

    <li>
      <label>
       <Radio
         checked={this.state.ts_status === "2"}
          value="2"
          onChange={(e) =>
            this.setState({
             ts_status: e.target.value
            })
          }
        />
        Already Claimed
      </label>
    </li>
  </ul>
</div>)}
		
 <div className="txtprojfrm">
		<>
		<p> <span className="validation">*</span>Upload Bill</p>
		<p className="upload-submitimg"><Button variant="standard" className="upldbtn" endIcon={<PhotoCamera />}>
  Upload
</Button>
<input type="file"  name="paybill"   onChange={this.onFileChange}  accept="image/*;capture=camera" /></p>
	<br/>{this.state.previocn!=="" &&(
	<p><img src={Serverurl+'uploads/' + this.state.previocn } target='_blank' style={{'width':'90px'}}/></p>
	)}
</>
		</div>
	  <div className="clear"></div>
        {/* AMOUNT + MODE */}
        <div className="amtModeSection">

          <div
            className="paytxtbox"
            style={{ flex: 1 }}
          >
            <p> <span className="validation">*</span>Amount</p>

            <TextField
              fullWidth
              size="small"
              value={this.state.ts_amount}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*\.?\d*$/.test(value)) {
                  this.setState({
                    ts_amount: value
                  });
                }
              }}
            />

           {this.state.selectedProjectInsert &&
 this.state.selectedVendorInsert && (
              <p
                style={{
                  color: "red",
                  marginTop: 10
                }}
              >
                Outstanding Amount: ₹{" "}
                {this.state.outstanding_amount}
              </p>
            )}
          </div>

          <div className="paytxtbox">
            <p><span className="validation">*</span>Mode of Payment</p>

            <ul className="paymodelist">
              <li>
                <label>
                  <Radio
                    checked={
                      this.state.ts_mode === "1"
                    }
                    value="1"
                    onChange={(e) =>
                      this.setState({
                        ts_mode:
                          e.target.value
                      })
                    }
                  />
                  Cash
                </label>
              </li>

              <li>
                <label>
                  <Radio
                    checked={
                      this.state.ts_mode === "2"
                    }
                    value="2"
                    onChange={(e) =>
                      this.setState({
                        ts_mode:
                          e.target.value
                      })
                    }
                  />
                  Bank Transfer
                </label>
              </li>

              <li>
                <label>
                  <Radio
                    checked={
                      this.state.ts_mode === "3"
                    }
                    value="3"
                    onChange={(e) =>
                      this.setState({
                        ts_mode:
                          e.target.value
                      })
                    }
                  />
                  UPI
                </label>
              </li>

              <li>
                <label>
                  <Radio
                    checked={
                      this.state.ts_mode === "4"
                    }
                    value="4"
                    onChange={(e) =>
                      this.setState({
                        ts_mode:
                          e.target.value
                      })
                    }
                  />
                  Cheque
                </label>
              </li>
            </ul>
          </div>
        </div>

        {/* REMARKS */}
        <div className="paytxtbox">
          <p>Remarks</p>

          <TextField
            fullWidth
            size="small"
            multiline
            rows={3}
            value={this.state.ts_remarks}
            onChange={(e) =>
              this.setState({
                ts_remarks: e.target.value
              })
            }
          />
        </div>

        {/* SUBMIT */}
        <div className="aligncenter">
                <Button
				
  variant="contained"
onClick={
  this.insertVendor
}
disabled={this.state.isDisabled}
  endIcon={
    <img
      src={SubmitIcon}
      alt="Submit"
      style={{ width: 20, height: 20 }}
    />
  }
>
{this.state.submitbtn}
</Button>

          {this.state.successMsg && (
            <p
              style={{
                
                color: "green",
                marginTop: "10px"
              }}
            >
              {this.state.successMsg}
            </p>
          )}
        </div>    </LocalizationProvider>
      </div>

  );
}
}
